import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "15",
  height: "13",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#CB4848",
      d: "M0 12.955 7.5 0 15 12.955zm2.352-1.364h10.296L7.5 2.727zm5.148-.682a.66.66 0 0 0 .486-.196.66.66 0 0 0 .196-.486.66.66 0 0 0-.197-.485.66.66 0 0 0-.485-.197.66.66 0 0 0-.485.197.66.66 0 0 0-.197.485q0 .29.197.486a.66.66 0 0 0 .485.196m-.682-2.045h1.364v-3.41H6.818z"
    }, null, -1)
  ]))]))
}
export default { render: render }